import { Card, Col, Divider, Row, Spin, Statistic, Typography } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import React from "react";
import { BookingProblem } from "../bookingRequest";
import BookingProblems from "../BookingProblems/BookingProblems";

const { Text, Title } = Typography;

interface Props {
  openTime: Date;
  secondsLeft: number;
  // True when the countdown has hit 0 and we are waiting for the server to confirm that booking is open
  waitingForServer: boolean;
  semester: string;
  companyId: number | undefined;
  problems: BookingProblem[] | undefined;
  onRecheck: () => void;
}

const Countdown: React.FC<Props> = ({
  openTime,
  secondsLeft,
  waitingForServer,
  semester,
  companyId,
  problems,
  onRecheck,
}) => {
  const days = Math.floor(secondsLeft / 86400);
  const hours = Math.floor((secondsLeft % 86400) / 3600);
  const minutes = Math.floor((secondsLeft % 3600) / 60);
  const seconds = secondsLeft % 60;

  const fullDate = new Intl.DateTimeFormat("no-NO", {
    weekday: "long",
    day: "numeric",
    month: "long",
    hour: "numeric",
    minute: "numeric",
  }).format(openTime);

  return (
    <Card style={{ width: "100%", margin: "20px 0" }}>
      <div style={{ textAlign: "center" }}>
        {/* aria-live announces the change to "åpner nå" to screen readers; the ticking numbers are left out on
            purpose, since announcing every second would be noise */}
        <Title level={4} aria-live="polite">
          {waitingForServer ? `Booking for ${semester} åpner nå` : `Booking for ${semester} har ikke åpnet enda`}
        </Title>
        <Text>Bookingen åpner {fullDate}. Kalenderen vises automatisk når bookingen åpner.</Text>
        <Row justify="center" gutter={32} style={{ marginTop: "25px" }}>
          <Col>
            <Statistic title="Dager" value={days} />
          </Col>
          <Col>
            <Statistic title="Timer" value={hours} />
          </Col>
          <Col>
            <Statistic title="Minutter" value={minutes} />
          </Col>
          <Col>
            <Statistic title="Sekunder" value={seconds} />
          </Col>
        </Row>
        {waitingForServer && (
          <div role="status" style={{ marginTop: "25px" }}>
            <Spin style={{ marginRight: "10px" }} />
            <Text strong>
              Venter på grønt lys – du sendes videre til kalenderen om noen sekunder. Ikke last inn siden på nytt.
            </Text>
          </div>
        )}
      </div>

      {problems && (
        <>
          <Divider />
          {problems.length === 0 ? (
            <Text>
              <CheckCircleOutlined style={{ color: "var(--success-color, #59c09c)", marginRight: "8px" }} />
              Alt er klart – dere kan booke så snart bookingen åpner.
            </Text>
          ) : (
            <BookingProblems problems={problems} companyId={companyId} onRecheck={onRecheck} />
          )}
        </>
      )}
    </Card>
  );
};

export default Countdown;
